import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/employee-portal`;

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('employee_token')}` } });

export const employeeApi = {
  linkInfo: (token) => axios.get(`${API}/links/${token}`),
  register: (payload) => axios.post(`${API}/register`, payload),
  reset: (payload) => axios.post(`${API}/reset`, payload),
  login: (email, password) => axios.post(`${API}/login`, { email, password }),
  me: () => axios.get(`${API}/me`, auth()),
  updateMe: (payload) => axios.patch(`${API}/me`, payload, auth()),
  clockIn: () => axios.post(`${API}/clock-in`, {}, auth()),
  clockOut: () => axios.post(`${API}/clock-out`, {}, auth()),
  summary: () => axios.get(`${API}/summary`, auth()),
  history: () => axios.get(`${API}/history`, auth()),
  payStubs: () => axios.get(`${API}/pay-stubs`, auth()),
};

export const money = (c) => ((c || 0) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
export const hrs = (secs) => `${((secs || 0) / 3600).toFixed(2)} hrs`;
export const timeOf = (iso) => new Date(iso).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
export const dayLabel = (d) => new Date(`${d}T00:00:00`).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
export const errMsg = (e, fb) => {
  const d = e.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || '').join(' ') || fb;
  return fb;
};
